var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.08 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1328af;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.77,246.1V235.25h7a23.59,23.59,0,0,0,0-47.17H352.9a23.43,23.43,0,0,0-13.6,4.33v-168A24.38,24.38,0,0,0,314.94,0H25.37A24.39,24.39,0,0,0,1,24.36V487.64A24.39,24.39,0,0,0,25.37,512H314.94a24.32,24.32,0,0,0,18.28-8.27c87.41,31,177.86-34.37,177.86-125.5A133.24,133.24,0,0,0,395.77,246.1ZM352.9,203.23h49.82a8.44,8.44,0,1,1,0,16.87H352.9a8.44,8.44,0,1,1,0-16.87Zm27.72,32v9.66c-1.87,0-3.75,0-5.62,0v-9.66Zm-41.32-4.33a23.5,23.5,0,0,0,13.6,4.33h7v10.84a132.91,132.91,0,0,0-20.56,4.44ZM469.43,452.7c-62.21,76.46-184.77,47.08-206.7-47.89A7.58,7.58,0,0,0,248,408.23a132.75,132.75,0,0,0,68.89,88.42c-1.45.31,15.06.2-291.49.2a9.22,9.22,0,0,1-9.22-9.21V24.36a9.22,9.22,0,0,1,9.22-9.21H314.94a9.22,9.22,0,0,1,9.22,9.21V256.11a133.3,133.3,0,0,0-79.61,120.27,7.58,7.58,0,0,0,15.15.19c.91-71.52,64.94-126.09,136.07-115.17C486,275.36,526.93,382,469.43,452.7Z",
    transform: "translate(-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.57,313.11a109.24,109.24,0,1,0-22.71,152.8A109.19,109.19,0,0,0,465.57,313.11ZM433.84,453.74a94.09,94.09,0,1,1,19.55-131.61A94.19,94.19,0,0,1,433.84,453.74Z",
    transform: "translate(-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377.81,321a7.57,7.57,0,0,0,7.57-7.58V297a7.57,7.57,0,0,0-15.14,0v16.47A7.57,7.57,0,0,0,377.81,321Z",
    transform: "translate(-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M422.2,301.27A7.58,7.58,0,0,0,411.85,304l-8.23,14.27a7.57,7.57,0,1,0,13.11,7.57L425,311.62A7.58,7.58,0,0,0,422.2,301.27Z",
    transform: "translate(-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.66,352.35l14.26-8.24A7.57,7.57,0,1,0,444.35,331l-14.27,8.23a7.58,7.58,0,0,0,7.58,13.12Z",
    transform: "translate(-1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M459,370.58H442.54a7.58,7.58,0,0,0,0,15.15H459a7.58,7.58,0,0,0,0-15.15Z",
    transform: "translate(-1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M451.92,412.2,437.66,404a7.58,7.58,0,0,0-7.58,13.12l14.27,8.24a7.57,7.57,0,0,0,7.57-13.12Z",
    transform: "translate(-1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M416.73,430.43A7.57,7.57,0,0,0,403.62,438l8.23,14.27A7.58,7.58,0,1,0,425,444.69Z",
    transform: "translate(-1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M377.81,435.31a7.57,7.57,0,0,0-7.57,7.58v16.47a7.57,7.57,0,0,0,15.14,0V442.89A7.57,7.57,0,0,0,377.81,435.31Z",
    transform: "translate(-1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.23,427.66a7.57,7.57,0,0,0-10.35,2.77l-8.23,14.26a7.58,7.58,0,0,0,13.12,7.58L352,438A7.57,7.57,0,0,0,349.23,427.66Z",
    transform: "translate(-1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318,404,303.7,412.2c-6.71,3.87-3.91,14.13,3.79,14.13,2.69,0,2.72-.4,18.05-9.25A7.58,7.58,0,0,0,318,404Z",
    transform: "translate(-1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M320.65,378.16a7.57,7.57,0,0,0-7.57-7.58H296.61a7.58,7.58,0,1,0,0,15.15h16.47A7.57,7.57,0,0,0,320.65,378.16Z",
    transform: "translate(-1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M303.7,344.11c15.51,9,15.39,9.25,18,9.25,7.72,0,10.49-10.26,3.8-14.13L311.27,331a7.57,7.57,0,1,0-7.57,13.11Z",
    transform: "translate(-1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M343.77,304a7.58,7.58,0,0,0-13.12,7.58l8.23,14.26A7.57,7.57,0,1,0,352,318.31Z",
    transform: "translate(-1)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5,352.17A7.57,7.57,0,1,0,391.75,344l-8.17,12.73a22.17,22.17,0,0,0-27.73,18.16c-2.91,19.6,19.39,32.79,35.18,21.1a22.16,22.16,0,0,0,5-30.54ZM382,383.82a7.05,7.05,0,1,1-4.28-12.72A7,7,0,0,1,382,383.82Z",
    transform: "translate(-1)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.82,65.86H285.48a7.58,7.58,0,0,0,0-15.15H54.82a7.58,7.58,0,0,0,0,15.15Z",
    transform: "translate(-1)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.79,88.54a7.58,7.58,0,1,0,0,15.15h68.67a7.58,7.58,0,1,0,0-15.15Z",
    transform: "translate(-1)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.82,103.69H123.5a7.58,7.58,0,0,0,0-15.15H54.82a7.58,7.58,0,0,0,0,15.15Z",
    transform: "translate(-1)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.55,169.16H54.82a7.58,7.58,0,0,0,0,15.15H231.55a7.58,7.58,0,1,0,0-15.15Z",
    transform: "translate(-1)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.48,169.16H261.85a7.58,7.58,0,1,0,0,15.15h23.63a7.58,7.58,0,0,0,0-15.15Z",
    transform: "translate(-1)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.82,222.14h65.75a7.57,7.57,0,0,0,0-15.14H54.82a7.57,7.57,0,0,0,0,15.14Z",
    transform: "translate(-1)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.91,287.62H54.82a7.58,7.58,0,0,0,0,15.15H219.91a7.58,7.58,0,1,0,0-15.15Z",
    transform: "translate(-1)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.82,340.6h60.59a7.58,7.58,0,1,0,0-15.15H54.82a7.58,7.58,0,0,0,0,15.15Z",
    transform: "translate(-1)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.3,325.45H145.71a7.58,7.58,0,0,0,0,15.15H206.3a7.58,7.58,0,1,0,0-15.15Z",
    transform: "translate(-1)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.81,373.9,89.57,447.83l-27.4-40.75a7.57,7.57,0,1,0-12.57,8.45l27.75,41.26a14.61,14.61,0,0,0,22,2.65L181,385.11a7.58,7.58,0,0,0-10.2-11.21Z",
    transform: "translate(-1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.124945b2f3d9d545aab31e0c71842548.svg";
export { ForwardRef as ReactComponent };